import styled from "styled-components";

const CategoryDisplayContainer = styled.div`
  background-color: ${props => props.gettingStarted ? "#dfead2" : "#ffffff"};
  border: ${props => props.gettingStarted ? "#1px solid #669933" : "none"};
  margin-top:10px;
  padding: ${props => props.gettingStarted ? "10px" : "0px"};
  border-radius: 7px;
  text-align: center;
`;

export default CategoryDisplayContainer;
